import React from "react";
import { TooManySelectionsPlaceholder } from "../../../../components";
import i18n from "../../../../i18n";
import {invalidErrorMessage} from "../../../../actions";

export default ({error}) => {
	const [title, description] = invalidErrorMessage(error);
	return <TooManySelectionsPlaceholder title={title} description={description} />;
};
